export const RedirectUrlType = {
  OAUTH: "oauth",
  SOCIAL: "social",
} as const;

export type RedirectUrlType = (typeof RedirectUrlType)[keyof typeof RedirectUrlType];
